import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters(['sessionContext']),
    ...mapState(['currentUserId']),
    portalUserId() {
      return this.currentUserId ?? null
    },
  },
}
